export class UserPersonalConditionModel {
    personalConditionTypeId: number;
    personalConditionTypeName: string;
    minValue: number;
    maxValue: number;
    isVisible: boolean;
}